import { getSelectedSport } from "../utils/helpers";

const GameStatsTabs = ({
  playersData = [],
  isPitchingTable = false,
  activeStatsTab = "batting",
  isLoading = false,
}) => {
  // Check if the selected sport is Women's Basketball
  const isWBB = getSelectedSport() === "WBB" /* || getSelectedSport() === "MBB" */;

  // Helper function to determine opponent team name
  const getOpponentTeam = (playerData) => {
    const playerTeam = playerData?.Team;
    const gameInfo = playerData?.GameInfo;
    if (!gameInfo || !playerTeam) return "N/A";

    return gameInfo.Home === playerTeam ? gameInfo.Visitor : gameInfo.Home;
  };

  // Helper function to get the game result
  const getGameResult = (playerData) => {
    const playerTeam = playerData?.Team;
    const gameInfo = playerData?.GameInfo;
    if (!gameInfo || !playerTeam) return "";

    const isHome = gameInfo.Home === playerTeam;
    const teamScore = isHome ? gameInfo.ScoreHome : gameInfo.ScoreVis;
    const opponentScore = isHome ? gameInfo.ScoreVis : gameInfo.ScoreHome;

    if (teamScore > opponentScore) {
      return "W";
    } else if (teamScore < opponentScore) {
      return "L";
    } else {
      return "T";
    }
  };

  // Helper function to get the score display
  const getScoreDisplay = (playerData) => {
    const playerTeam = playerData?.Team;
    const gameInfo = playerData?.GameInfo;
    if (!gameInfo || !playerTeam) return "";

    const isHome = gameInfo.Home === playerTeam;
    const teamScore = isHome ? gameInfo.ScoreHome : gameInfo.ScoreVis;
    const opponentScore = isHome ? gameInfo.ScoreVis : gameInfo.ScoreHome;

    const scores = [teamScore, opponentScore];
    const [higherScore, lowerScore] = scores.sort((a, b) => b - a);
    return `${higherScore}-${lowerScore}`;
    // return `${teamScore}-${opponentScore}`;
  };

  // Format date from API response
  const formatGameDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const thClass = "py-3 px-4 text-left text-sm font-medium text-[#999999] border-b border-[#1A1A1A]";
  const tdClass = "py-3 px-4 text-sm text-[#F5F5F5] border-b border-[#1A1A1A]";
  const tdBorderOnly = "py-3 px-4 text-sm font-medium border-b border-[#1A1A1A]";

  return (
    <div className="w-full mx-auto overflow-hidden bg-[#0A0A0A] transition-colors">
      {/* Tab Content */}
      <div>
        {isWBB ? (
          <div>
            <div className="flex">
              <h3 className="text-xl font-bold text-[#F5F5F5] mb-6">
                Game Stats
              </h3>
            </div>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#111111]">
                  <th className={thClass}>Date</th>
                  <th className={thClass}>Opponent</th>
                  <th className={thClass}>Result</th>
                  <th className={thClass}>Score</th>
                  <th className={thClass}>MIN</th>
                  <th className={thClass}>PTS</th>
                  <th className={thClass}>FGM</th>
                  <th className={thClass}>FGA</th>
                  <th className={thClass}>3PM</th>
                  <th className={thClass}>3PA</th>
                  <th className={thClass}>FTM</th>
                  <th className={thClass}>FTA</th>
                  <th className={thClass}>REB</th>
                  <th className={thClass}>OREB</th>
                  <th className={thClass}>AST</th>
                  <th className={thClass}>STL</th>
                  <th className={thClass}>BLK</th>
                  <th className={thClass}>TO</th>
                  <th className={thClass}>PF</th>
                </tr>
              </thead>
              <tbody className="bg-[#0A0A0A]">
                {isLoading ? (
                  <tr>
                    <td colSpan="19" className="py-6 text-center">
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-[#E8B800] mr-2"></div>
                        <span className="text-[#555555]">
                          Loading stats...
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : playersData && playersData.length > 0 ? (
                  playersData.map((playerData, i) => (
                    <tr
                      key={i}
                      className="hover:bg-[rgba(255,255,255,0.04)]"
                    >
                      <td className={tdClass}>
                        {formatGameDate(
                          playerData?.GameInfo?.GameDay || playerData?.GameDay
                        )}
                      </td>
                      <td className={tdClass}>
                        {playerData?.Opponent}
                      </td>
                      <td className={tdBorderOnly}>
                        {playerData?.WinOrLoss === "W" ? (
                          <span className="text-green-600">
                            {playerData?.WinOrLoss}
                          </span>
                        ) : (
                          <span className="text-red-600">
                            {playerData?.WinOrLoss}
                          </span>
                        )}
                      </td>
                      <td className={tdClass}>
                        {getScoreDisplay(playerData)}
                      </td>
                      <td className={tdClass}>
                        {playerData?.MIN}
                      </td>
                      <td className={tdClass}>
                        {playerData?.PTS}
                      </td>
                      <td className={tdClass}>
                        {playerData?.FGM}
                      </td>
                      <td className={tdClass}>
                        {playerData?.FGA}
                      </td>
                      <td className={tdClass}>
                        {playerData?.ThreePM}
                      </td>
                      <td className={tdClass}>
                        {playerData?.ThreePA}
                      </td>
                      <td className={tdClass}>
                        {playerData?.FTM}
                      </td>
                      <td className={tdClass}>
                        {playerData?.FTA}
                      </td>
                      <td className={tdClass}>
                        {playerData?.REB}
                      </td>
                      <td className={tdClass}>
                        {playerData?.OREB}
                      </td>
                      <td className={tdClass}>
                        {playerData?.AST}
                      </td>
                      <td className={tdClass}>
                        {playerData?.STL}
                      </td>
                      <td className={tdClass}>
                        {playerData?.BLK}
                      </td>
                      <td className={tdClass}>
                        {playerData?.TO}
                      </td>
                      <td className={tdClass}>
                        {playerData?.PF}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="19"
                      className="py-6 text-center text-sm text-[#555555]"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : getSelectedSport() == 'CBB' ? (
          <>
            {!isPitchingTable ? <div>
              <div className="flex">
                <h3 className="text-xl font-bold text-[#F5F5F5] mb-6">
                  Batting Stats
                </h3>
              </div>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-[#111111]">
                    <th className={thClass}>Date</th>
                    <th className={thClass}>Opponent</th>
                    <th className={thClass}>Result</th>
                    <th className={thClass}>Score</th>
                    <th className={thClass}>AB</th>
                    <th className={thClass}>R</th>
                    <th className={thClass}>H</th>
                    <th className={thClass}>RBI</th>
                    <th className={thClass}>SO</th>
                    <th className={thClass}>2B</th>
                    <th className={thClass}>3B</th>
                    <th className={thClass}>HR</th>
                  </tr>
                </thead>
                <tbody className="bg-[#0A0A0A]">
                  {isLoading ? (
                    <tr>
                      <td colSpan="12" className="py-6 text-center">
                        <div className="flex justify-center items-center">
                          <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-[#E8B800] mr-2"></div>
                          <span className="text-[#555555]">
                            Loading stats...
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : playersData && playersData.length > 0 ? (
                    playersData.map((playerData, i) => (
                      <tr
                        key={i}
                        className="hover:bg-[rgba(255,255,255,0.04)]"
                      >
                        <td className={tdClass}>
                          {formatGameDate(playerData?.GameInfo?.GameDay)}
                        </td>
                        <td className={tdClass}>
                          {getOpponentTeam(playerData)}
                        </td>
                        <td className={tdBorderOnly}>
                          {getGameResult(playerData) === "W" ? (
                            <span className="text-green-600">
                              {getGameResult(playerData)}
                            </span>
                          ) : (
                            <span className="text-red-600">
                              {getGameResult(playerData)}
                            </span>
                          )}
                        </td>
                        <td className={tdClass}>
                          {getScoreDisplay(playerData)}
                        </td>
                        <td className={tdClass}>
                          {playerData?.AB}
                        </td>
                        <td className={tdClass}>
                          {playerData?.R}
                        </td>
                        <td className={tdClass}>
                          {playerData?.H}
                        </td>
                        <td className={tdClass}>
                          {playerData?.RBI}
                        </td>
                        <td className={tdClass}>
                          {playerData?.SO}
                        </td>
                        <td className={tdClass}>
                          {playerData?.TwoBA}
                        </td>
                        <td className={tdClass}>
                          {playerData?.ThreeBA}
                        </td>
                        <td className={tdClass}>
                          {playerData?.HR}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="12"
                        className="py-6 text-center text-sm text-[#555555]"
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
              : <div>
                <div className="flex">
                  <h3 className="text-xl font-bold text-[#F5F5F5] mb-6">
                    Pitching Stats
                  </h3>
                </div>
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-[#111111]">
                      <th className={thClass}>Date</th>
                      <th className={thClass}>Opponent</th>
                      <th className={thClass}>Result</th>
                      <th className={thClass}>Score</th>
                      <th className={thClass}>IP</th>
                      <th className={thClass}>BF</th>
                      <th className={thClass}>ER</th>
                      <th className={thClass}>BB</th>
                      <th className={thClass}>SO</th>
                      <th className={thClass}>HR</th>
                      <th className={thClass}>PIT</th>
                      <th className={thClass}>W-L</th>
                      <th className={thClass}>SV</th>
                    </tr>
                  </thead>
                  <tbody className="bg-[#0A0A0A]">
                    {isLoading ? (
                      <tr>
                        <td colSpan="13" className="py-6 text-center">
                          <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-[#E8B800] mr-2"></div>
                            <span className="text-[#555555]">Loading stats...</span>
                          </div>
                        </td>
                      </tr>
                    ) : playersData && playersData.length > 0 ? (
                      playersData.map((playerData, i) => (
                        <tr
                          key={i}
                          className="hover:bg-[rgba(255,255,255,0.04)]"
                        >
                          <td className={tdClass}>
                            {formatGameDate(playerData?.GameInfo?.GameDay)}
                          </td>
                          <td className={tdClass}>
                            {getOpponentTeam(playerData)}
                          </td>
                          <td className={tdBorderOnly}>
                            {getGameResult(playerData) === "W" ? (
                              <span className="text-green-600">
                                {getGameResult(playerData)}
                              </span>
                            ) : (
                              <span className="text-red-600">
                                {getGameResult(playerData)}
                              </span>
                            )}
                          </td>
                          <td className={tdClass}>
                            {getScoreDisplay(playerData)}
                          </td>
                          <td className={tdClass}>{playerData?.IP}</td>
                          <td className={tdClass}>{playerData?.BF}</td>
                          <td className={tdClass}>{playerData?.ER}</td>
                          <td className={tdClass}>{playerData?.BB}</td>
                          <td className={tdClass}>{playerData?.SO}</td>
                          <td className={tdClass}>{playerData?.HR}</td>
                          <td className={tdClass}>{playerData?.PIT}</td>
                          <td className={tdClass}>
                            {playerData?.W}-{playerData?.L}
                          </td>
                          <td className={tdClass}>{playerData?.SV}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="13"
                          className="py-6 text-center text-sm text-[#555555]"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default GameStatsTabs;
